import { Directive, Input, Output, EventEmitter, OnInit } from '@angular/core';
// import { Directive, Input, Output, EventEmitter, OnInit } from 'angular/core';

@Directive({
    selector: '[uppercase]',
    host: {
        '[value]': 'uppercase',
        '(input)': 'format($event.target.value)'
    }
})
export class UppercaseDirective {

    @Input() uppercase: string;
    @Output() uppercaseChange: EventEmitter<string> = new EventEmitter<string>();

    constructor() {
    }

    ngOnInit() {
        this.uppercase = this.uppercase || '';
        this.format(this.uppercase);
    }

    format(value) {
        value = value.toUpperCase();
        this.uppercaseChange.next(value);
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_directives/uppercase.directive.ts